import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { N1TimeSeriesEdit } from "./edit";
import { N1TimeSeriesNew } from "./new";
import { N1TimeSeriesTable } from "./table";

export default function N1TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<N1TimeSeriesEdit />} />
      <Route index element={<N1TimeSeriesTable />} />
      <Route path="/new" element={<N1TimeSeriesNew />} />
    </Routes>
  );
}
